import React, { Component } from "react";
import { Button, Grid, Row, Col } from "react-bootstrap";
import BaseModal from "./base_modal";
import "./modal.scss";
import "../../css/delete_modal.scss";

class EpisodeDeleteModal extends Component {
  render() {
    return (
      <BaseModal
        isLoading={this.props.isLoading}
        title={"Delete Episode"}
        showContent={true}
        close={this.props.closeModal}
        Content={() => {
          return (
            <Grid fluid>
              <Row>
                <Col md={10} mdOffset={1} xs={12}>
                  <div className="delete-modal-content">
                    Are you sure you want to delete this episode?
                    <em>This action cannot be undone.</em>
                  </div>
                </Col>
              </Row>
            </Grid>
          );
        }}
        Footer={() => {
          return (
            <Grid fluid>
              <Row>
                <Col mdOffset={1} md={5} xs={6}>
                  <Button className="btn-secondary modal-button" onClick={this.props.closeModal}>
                    Cancel
                  </Button>
                </Col>
                <Col md={5} xs={6}>
                  <Button
                    className="btn-primary modal-button"
                    onClick={() =>
                      this.props
                        .deleteEpisode(this.props.episodeUUID, this.props.user)
                        .then(response => {
                          if (response.status === 200) {
                            this.props.history.push("/shows/" + this.props.showUUID);
                            this.props.closeModal();
                          }
                        })
                    }>
                    Delete
                  </Button>
                </Col>
              </Row>
            </Grid>
          );
        }}
      />
    );
  }
}

export default EpisodeDeleteModal;
